import React, { Component } from 'react';
import Corkboard from './components/Corkboard';
import CardInfo from './components/CardInfo';
import Lamp from './components/Lamp';
import Footer from './components/Footer';
import { VelocityTransitionGroup } from 'velocity-react';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCard: null
    };
    this.selectCard = this.selectCard.bind(this);
  }

  selectCard(card) {
    this.setState(() => {
      return {
        selectedCard: card
      }
    });
  }

  render() {
    return (
      <div className={`wrapper ${this.state.selectedCard ? 'info' : 'board'}`}>
        {this.state.selectedCard ? undefined : <Lamp /> }
        <div className="container">
          <h4 className="small-device-text">For small devices, this site is best viewed horizontally.</h4>
            <VelocityTransitionGroup enter={{animation: "fadeIn", delay: 500}} leave={{animation: "fadeOut"}}>
              {this.state.selectedCard 
                ? undefined 
                : <Corkboard selectCard={this.selectCard} />}
          </VelocityTransitionGroup>
          <VelocityTransitionGroup enter={{animation: "fadeIn", delay: 500}} leave={{animation: "fadeOut"}}>
              {this.state.selectedCard 
                ? <CardInfo selectedCard={this.state.selectedCard} selectCard={this.selectCard} />
                : undefined }
          </VelocityTransitionGroup>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js